



















































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Utils } from "@/core/Utils";
import BaseVue from "@/core/BaseVue";

@Component({
  name: "acceder",
  components: {},
})
export default class Acceder extends BaseVue {
  cedulaMessage: string = "";
  cedulaMask = "";
  cedula = "";
  password = "";
  loading = false;
  error = false;
  errMessage = "";
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }

  get isCedula() {
    return this.cedulaMask ? Utils.isCedula(this.cedulaMask) : false;
  }

  @Watch("cedulaMask")
  onCedulaBlur() {
    this.cedulaMessage = this.isCedula ? "" : "Cédula incorrecta";
  }

  async login() {
    try {
      var result = await this.$validator.validateAll();
      if (result) {
        this.cedula = this.cedulaMask.replace(/-/g, "");
        let username = this.cedula;
        let password = this.password;
        this.loading = true;
        this.$store
          .dispatch("login", { username, password })
          .then(() => {
            this.$router.push("/");
          })
          .catch((err) => {
            if (
              err.message &&
              err.message == "Este usuario esta bloqueado."
            ) {
              this.errMessage =
                "Este usuario esta bloqueado. Favor contactar con una de las oficinas de PS.";
            } else if (err.message) {
              this.errMessage = err.message;
            }
            this.error = true;
          })
          .finally(() => {
            this.loading = false;
          });
        return;
      }
      throw this.$validator.errors.items.map((e) => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
}
